import React from 'react';
import PropTypes from 'prop-types';

import MotifFormField from '@ey/motif-react-wrapper/FormField';
import CCSReactSelect from '@ey/canvascoreservices/ReactSelect';

const ReactSelect = ({...rest}) => (
	<MotifFormField>
		<CCSReactSelect {...rest} />
	</MotifFormField>
);

ReactSelect.propTypes = {};

export default ReactSelect;
